import React, { Component } from 'react';
import { Helmet } from "react-helmet";

class About extends Component {
  componentDidMount() {
    document.getElementById('root').classList.remove('welcome');
    document.getElementById('foo').classList.add('overflow');
  }
  render() {
    return (
      <div className="sub-page">
        <Helmet>
          <title>STech - Cookies</title>
          <meta name="description" content="STech - Cookies pages" />
        </Helmet>
        <header className="clearfix fadeInUp">
          <div className="container">
            <div className="left"></div>
            <div className="right">
              <h1>Cookies</h1>
              <h2>Version 1.0</h2>
            </div>
          </div>
        </header>
        <section className="clearfix terms fadeInUp">
          <div className="container">
            <div className="content">
              <h2>1. About Cookies</h2>
              <p>STech Technology UK Limited is a company incorporated in England and Wales with company number 10897880 and whose registered address is at South Quay Building, 77 Marsh Wall, London, England, E14 9SH (&ldquo;STech&rdquo; &ldquo;Company&rdquo;, &ldquo;we&rdquo;,&nbsp;&ldquo;us&rdquo;).</p>
              <p><br />Cookies are small text files containing information that we, like most websites, store in your browser and can retrieve whilst you are browsing the website. This data is used to improve your user experience by storing your preferences and helping you make the best and most efficient use of our Website.</p>
              <h2>2. What Cookies are used for</h2>
              <p>Our cookies are used to:</p>
              <p>- provide basic functions for your convenience on our Website</p>
              <p>- enhance the functionality of the Website</p>
              <p>- improve the performance of the Website</p>
              <p>For example, we may use cookies to assess how you use our Website, which pages you visit, how much time you spend on our Website and similar.</p>
              <p>Some cookies only last until the termination of a session of a given browser on the Website, whilst other cookies are persistent, meaning that they shall remain on your device until deleted and allow us to access personal date from your device.</p>
              <h2>3. Disabling Cookies</h2>
              <p>When you first visit the Website, you are given the option to either provide or not provide your consent to our collecting cookies. If you choose not to give us consent to collect cookies we shall not collect cookies from you, but you may find that you are unable to access certain content on our Website or have the most efficient and enjoyable experience on our Website. We therefore recommend that you do not prevent us from using cookies and accept no liability to you for any losses you may occur as a result of disabling cookies.</p>
              <p>Even if you grant us consent to collect cookies, you may withdraw this consent at any time by changing your preferences in your Account Settings.</p>
              <p>To clear cookies previously placed on your browser, you should select the option to clear your browsing history and ensure that the option to delete or clear cookies is included when you do so.</p>
              <h2>4. Third Party Cookies</h2>
              <p>Some cookies on our Website may not be related to us. Third parties, such as YouTube, often post their content on others&rsquo; websites. Such cookies are not controlled by us and cannot be accessed by us. Please inspect the cookie policy of the third party for further details. You may also be able to accept or reject some or all cookies from third parties by adjusting your browser settings.</p>
              <h2>5. Further Information</h2>
              <p>Further information about cookies is available on <u><a href="http://www.aboutcookies.org">www.aboutcookies.org</a></u> and elsewhere on the Internet.</p>
              <p>The <a href="https://html-cleaner.com/css/">free online CSS code beautifier</a> takes care of your dirty code and strips every unwanted</p>

            </div>
          </div>
        </section>
      </div>
    )
  }
}
export default About
